<template>
    <div class="contentbox areacode">
      <div class="toptitle">
        <span class="return">
          <span @click="$router.go(-1)">&lt;</span>
        </span>
        请选择区号
        <span @click="onsave" class="topimgbox rg">
          保存
        </span>
      </div>
      <div class="setaddressbox">
        <div class="title">请选择区号</div>
        <!--<Radio-->
          <!--align="right"-->
          <!--v-model="value"-->
          <!--:options="options">-->
        <!--</Radio>-->
        <ul>
          <li v-for="itme in options" :key="itme.region_num">
            <el-radio v-model="value" :label="itme.region_num">
              {{itme.region_num}} ({{itme.region_name}})
            </el-radio>
          </li>
        </ul>
      </div>

    </div>
</template>

<script>
  import { Radio } from 'mint-ui';
  import { getCode } from '../assets/js/api'
    export default {
        name: "selectareacode",
        data(){
          return {
            value:this.$store.state.phoneCode,
            options:[]
          }
        },
        components:{
          Radio,
        },
        mounted(){
          getCode().then((data)=>{
            // this.options = data.map(itme=>itme.region_num)
            for(let time in data){
              if (data[time].region_num){
                this.options.push(data[time])
              }
            }
          })
        },
        methods:{
          onsave(){
            this.$store.commit('set_phoneCode',this.value)
            // this.$router.push({ path: '/register'});
            this.$router.go(-1)
          },

        },
        computed:{
        }
    }
</script>

<style lang="less">
  @import "../assets/less/base";

  .contentbox.areacode{
    background-color: #fff;
    width: 100%;
    .toptitle{
      background-color: @maincolor;
      height: 52px;
      font-size: 16px;
      line-height: 52px;
      color: #fff;
      box-shadow: 0px 2px 5px 2px #e8e8e8;
      text-align: center;
      position: relative;
      .return{
        font-size: 40px;
        position: absolute;
        left: 0.2rem;
        cursor: pointer;
      }
      .topimgbox{
        position: absolute;
        left: 87%;
        cursor: pointer;
      }
    }
    .setaddressbox{
      display: flex;
      flex-direction: column;
      align-items: center;
      .title{
        margin: 0.4rem;
        font-size: 16px;
      }
      ul{
        li{
          margin: 20px 0;
          font-size: 26px;
        }
      }
      .mint-cell-title,.mint-radiolist-label{
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/selectareacode.vue